import "./styles.scss";

const ChartePage = () => {
  return (
    <div className="chartes">
      <h1>Charte Handicap</h1>
      <p>Référent Handicap : Nathalie Lévy</p>
      <p>
        Secteur : Formation, Accompagnement des Personnes en Situation de
        Handicap
      </p>
      <h2>1. Connaissances et Expertise</h2>
      <p>
        En tant que référente handicap, Nathalie Lévy bénéficie d'une expertise
        et d'une expérience solide dans l’accompagnement des personnes
        handicapées, aussi bien dans le secteur hospitalier que dans le domaine
        de la formation professionnelle. Sa pratique inclut :
        <br />• L'écoute active : comprendre les besoins individuels de chaque
        participant.
        <br />• L’adaptabilité : ajuster les méthodes pédagogiques en fonction
        des limitations spécifiques.
        <br />• La facilitation : créer un environnement de formation où chacun
        se sent inclus et soutenu.
      </p>
      <h2>2. Compétences et Engagement</h2>
      <p>
        Nathalie Lévy côtoie des personnes en situation de handicap, ce qui lui
        permet de mieux comprendre les défis auxquels ces personnes font face.
        Elle travaille également en partenariat avec un réseau d’organismes
        spécialisés pour optimiser l’accompagnement des personnes handicapées en
        formation.
      </p>
      <h2>3. Formations Adaptées</h2>
      <p>
        Nous proposons des formations adaptées aux personnes en situation de
        handicap, en offrant :
        <br />• Une évaluation des besoins spécifiques avant chaque formation.
        <br />• Des aménagements pédagogiques : supports adaptés, temps
        supplémentaires, modalités d’examen ajustées.
        <br />• Un suivi personnalisé : l’accompagnement continue des apprenants
        tout au long de leur parcours.
      </p>
      <h2>4. Outils et Documentation</h2>
      <p>
        Pour personnaliser l’approche, un document de suivi des besoins
        spécifiques est utilisé pour chaque participant. Ces outils permettent
        une personnalisation de la formation et assurent que les ajustements
        nécessaires sont mis en place.
      </p>
      <h2>5. Engagement envers l’Amélioration Continue</h2>
      <p>
        Nous mettons en place une veille continue sur les meilleures pratiques
        pédagogiques adaptées, pour nous assurer que nos formations répondent
        aux normes d’accessibilité. Le suivi des formations permet également
        d’identifier les points d'amélioration.
      </p>
      <h2>6. Impact et Résultats</h2>
      <p>
        Grâce à cette démarche, nous observons :
        <br />• Une accessibilité améliorée des formations pour les personnes en
        situation de handicap.
        <br />• Une meilleure satisfaction des apprenants handicapés.
        <br />• Un suivi personnalisé garantissant la réussite et l'intégration
        des participants dans leur parcours de formation.
      </p>
    </div>
  );
};

export default ChartePage;
